import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { pluck } from 'rxjs/operators'
import {
  MB_PRODUCT_TAB_APPLICATIONS_NORMALIZER,
  MbProductTabApplicationsAdapter
} from '../connectors'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductTabApplicationsAdapter implements MbProductTabApplicationsAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http.get(this.getEndpoint(productCode, maxCount)).pipe(
      pluck('applications'),
      this.converter.pipeable(MB_PRODUCT_TAB_APPLICATIONS_NORMALIZER)
    )
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productTabApplications',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}
